const tokenRegistryVersions = [
    {
        id: "V5",
        name: "V5 (MLETR + IGP&I)",
    },
    {
        id: "V4",
        name: "V4 (MLETR)",
    }
]

export default tokenRegistryVersions;